export { default } from './SpecialDeals';
